import { lazy } from 'react';

const CustomMobilityReportsSearcher = lazy(() => import('./CustomMobilityReportsSearcher'));

export default CustomMobilityReportsSearcher;
